import { GrfqBbo } from '#/unified-rfqs/entities/grfq/bbo';
import EntityStore from './entity';

export interface GrfqBboWithId extends GrfqBbo {
  // grfq id
  id: number;
}

export default class GrfqBboStore extends EntityStore<GrfqBboWithId> {}
